<template>
  <!-- Mismo marcado que genera b-form-group con label-cols="4" label-cols-sm="3"
       (ModalityForm, EgressProfileForm), para que se vea igual que el resto de los
       formularios sin usar Bootstrap-Vue -->
  <div>
    <div role="group" class="form-group label">
      <div class="form-row">
        <label
          for="input-realization-scope-name"
          class="col-4 col-sm-3 col-form-label"
          >{{ $t("reusable.common.name") }}</label
        >
        <div class="col">
          <input
            id="input-realization-scope-name"
            v-model="form.name"
            type="text"
            class="form-control form-control-sm"
            :class="{ 'is-invalid': submitted && !nameIsValid }"
            aria-describedby="input-realization-scope-name-live-feedback"
          />
          <div
            id="input-realization-scope-name-live-feedback"
            class="invalid-feedback"
          >
            {{ $t("reusable.common.minLength", { min: 3 }) }}
          </div>
        </div>
      </div>
    </div>
    <div role="group" class="form-group label">
      <div class="form-row">
        <label
          for="input-realization-scope-description"
          class="col-4 col-sm-3 col-form-label"
          >{{ $t("reusable.common.description") }}</label
        >
        <div class="col">
          <!-- Texto plano (no rich text): se muestra con saltos de línea en el listado
               y se escribe tal cual en el Word del perfil de egreso -->
          <textarea
            id="input-realization-scope-description"
            v-model="form.description"
            rows="3"
            class="form-control form-control-sm"
          ></textarea>
        </div>
      </div>
    </div>
    <div v-if="!isNew" class="p-0 m-0 mt-2">
      <ModificationDate :Information="realization_scope"></ModificationDate>
    </div>
    <div class="row">
      <div class="col" style="text-align: right">
        <!-- Deshabilitado mientras se guarda: varios clics creaban varios ámbitos -->
        <button
          type="button"
          class="btn btn-secondary btn-sm m-0"
          :disabled="saving"
          @click="save"
        >
          <span
            v-if="saving"
            class="spinner-border spinner-border-sm mr-1"
            aria-hidden="true"
          ></span>
          {{
            saving ? $t("reusable.common.saving") : $t("reusable.common.save")
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
// eslint-plugin-vue 6.x (anterior a <script setup>) no ve que estos bindings
// se usan en el template. Quitar el disable cuando se actualice el tooling.
/* eslint-disable no-unused-vars */
// Crear o editar un Ámbito de realización de un perfil de egreso. El orden no se edita
// aquí: el backend deja los nuevos al final y se reordenan arrastrando en el listado.
// Legacy (Bootstrap-Vue): ModificationDate es el pie de auditoría compartido.
import { computed, getCurrentInstance, reactive, ref } from "vue";
import * as names from "@/store/names";
import { toast } from "@/utils/utils";
import ModificationDate from "@/components/reusable/ModificationDate";

const props = defineProps({
  // Ámbito a editar; null para crear uno nuevo
  realization_scope: {
    type: Object,
    default: null,
  },
  egress_profile_id: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(["created", "updated"]);

const proxy = getCurrentInstance().proxy;

const isNew = computed(() => !props.realization_scope);
const form = reactive({
  name: props.realization_scope ? props.realization_scope.name : "",
  description: props.realization_scope
    ? props.realization_scope.description
    : "",
});
const submitted = ref(false);
const saving = ref(false);

const nameIsValid = computed(() => form.name.trim().length >= 3);

function entityName() {
  return proxy.$getVisibleNames(
    "mesh.egressprofilerealizationscope",
    false,
    "Ámbito de realización"
  );
}

function save() {
  if (saving.value) return;
  submitted.value = true;
  if (!nameIsValid.value) return;
  const item = {
    egress_profile: props.egress_profile_id,
    name: form.name.trim(),
    description: form.description,
  };
  saving.value = true;
  const request = isNew.value
    ? proxy.$store.dispatch(names.POST_REALIZATION_SCOPE, item)
    : proxy.$store.dispatch(names.PATCH_REALIZATION_SCOPE, {
        realization_scope_id: props.realization_scope.id,
        item: item,
      });
  // Si falla, api.js ya mostró el error: solo se vuelve a habilitar el botón
  request
    .then((response) => {
      toast(
        entityName() +
          " " +
          proxy.$t(
            isNew.value ? "reusable.common.created" : "reusable.common.updated"
          )
      );
      emit(isNew.value ? "created" : "updated", response);
    })
    .catch(() => {})
    .finally(() => {
      saving.value = false;
    });
}
</script>
